import api from "../../services/api";

const BASE_URL = "/api/v1/employees";

export const employeeService = {
  // Get all employees - GET /api/v1/employees
  getAllEmployees: async () => {
    try {
      const response = await api.get(BASE_URL);
      console.log("Employee service response:", response);
      // Extract the data array from the response structure
      return response.data.data || [];
    } catch (error) {
      console.error("Employee service error:", error);
      throw error;
    }
  },

  // Get employee by ID - GET /api/v1/employees/:id
  getEmployeeById: async (id) => {
    const response = await api.get(`${BASE_URL}/${id}`);
    // Extract the employee data from the response structure
    return response.data.data || response.data;
  },

  // Create new employee - POST /api/v1/employees
  createEmployee: async (employeeData) => {
    const response = await api.post(BASE_URL, {
      ...employeeData,
      frontendUrl: window.location.origin, // Send current frontend URL for invitation emails
    });
    return response.data;
  },

  // Update employee - PUT /api/v1/employees/:id
  updateEmployee: async (id, employeeData) => {
    const response = await api.put(`${BASE_URL}/${id}`, employeeData);
    return response.data;
  },

  // Delete employee - DELETE /api/v1/employees/:id
  deleteEmployee: async (id) => {
    const response = await api.delete(`${BASE_URL}/${id}`);
    return response.data;
  },

  // Manage employee password - POST /api/v1/employees/:id/password
  managePassword: async (id, action, password = null, role = null) => {
    const response = await api.post(`${BASE_URL}/${id}/password`, {
      action, // "auto-generate", "manual-password", "invite-link", "remove-access"
      password,
      role,
      frontendUrl: window.location.origin, // Send current frontend URL for invitation emails
    });
    return response.data;
  },

  // Get dynamic department and designation lists from company settings
  // GET /api/v1/employees/meta
  getMetaOptions: async () => {
    try {
      const response = await api.get(`${BASE_URL}/meta`);
      return response.data.data || { departments: [], designations: [] };
    } catch (error) {
      console.error("Failed to fetch meta options:", error);
      return { departments: [], designations: [] };
    }
  },
};
